import React, { CSSProperties } from 'react';
import { Link } from 'react-router-dom';
import styles from './form.module.scss';

interface Props {
  to: string | { pathname: string };
  theme?: 'primary' | 'secondary' | 'white' | 'danger';
  disabled?: boolean;
  target?: string;
  style?: CSSProperties;
}

export function LinkButton(props: React.PropsWithChildren<Props>) {
  const classNameList = [styles.btn];

  if (props.theme) {
    if (props.theme === 'primary') classNameList.push(styles.btn_primary);
    if (props.theme === 'secondary') classNameList.push(styles.btn_secondary);
  } else {
    classNameList.push(styles.btn_primary);
  }

  if (props.disabled) {
    return <span className={styles.btn}>{props.children}</span>;
  }

  if (props.target) {
    return (
      <a className={classNameList.join(' ')} href={props.to as string} target={props.target}>
        {props.children}
      </a>
    );
  }

  return (
    <Link style={props.style} className={classNameList.join(' ')} to={props.to} target={props.target}>
      {props.children}
    </Link>
  );
}
